import * as React from "react"
import { Box, Tooltip } from "@mui/material"
import { useSignal } from "@preact/signals-react"
import { IconSeeker, PopoverSeeker, PopoverSeekerItem } from "@ui-seeker/core"
import { track } from "@analytics"


export default function AppTableExportMenu({ onDownloadExcel, downloadCSVOptions }) {
    const anchorEl = useSignal(null)
    const isLoading = useSignal(false)

    const handleClick = (e) => {
        e.stopPropagation()
        if (downloadCSVOptions?.length) {
            anchorEl.value = e.currentTarget
        } else {
            triggerDownload({})
        }
    }

    // ⚠️ Partial coverage: this menu is only used by Monitoring › Results. Every other table in the
    // app is `TableSeeker` from `@ui-seeker/core` and exports through the package's own toolbar, out
    // of reach from here — see the catalogue (`Docs/product-analytics-dipi.md`).
    // `option` names the CSV variant the user picked; a plain Excel download sends no props, like
    // PUIG's `excel_downloaded`.
    const triggerDownload = (extraData, option) => {
        anchorEl.value = null
        isLoading.value = true
        track('excel_downloaded', option ? { option } : undefined)
        onDownloadExcel(extraData).finally(() => isLoading.value = false)
    }

    return <>
        <Tooltip title="Download Excel">
            <Box onClick={handleClick} sx={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
                {isLoading.value
                    ? <IconSeeker icon="spinner" isSpin />
                    : <IconSeeker icon="down-to-line" sx={{ fontSize: "1.25rem" }} />
                }
            </Box>
        </Tooltip>

        {!!downloadCSVOptions?.length && <PopoverSeeker
            anchorEl={anchorEl.value}
            onClose={() => anchorEl.value = null}
        >
            {downloadCSVOptions.map(opt => <PopoverSeekerItem
                key={opt.label}
                icon={opt.icon}
                label={opt.label}
                onClick={() => triggerDownload(opt.extraData, opt.label)}
            />)}
        </PopoverSeeker>}
    </>
}
